import FileTypeGroup from "./FileTypeGroup";
import FunctionHelper from "../../../shared/helper/FunctionHelper";

export default class FileTypeGroupFilter {
	private _whitelist: Array<FileTypeGroup>;
	private _blacklist: Array<FileTypeGroup>;

	constructor(blacklist: Array<FileTypeGroup>, whitelist?: Array<FileTypeGroup>) {
		this._whitelist = FunctionHelper.applyValue(whitelist, []);
		this._blacklist = blacklist;
	}

	public static check(fileTypeGroups: string, whitelist?: Array<FileTypeGroup>, blacklist?: Array<FileTypeGroup>) {
		if (FunctionHelper.exists(whitelist) && whitelist!.length > 0) {
			if (!this.filter(fileTypeGroups, whitelist!)) {
				return false;
			}
		}

		return !this.filter(fileTypeGroups, FunctionHelper.applyValue(blacklist, []));
	}


	public check(fileTypeGroups: string): boolean {
		return FileTypeGroupFilter.check(fileTypeGroups, this.whitelist, this.blacklist);
	}

	public static checkSelection(
		selection: Array<string>, whitelist?: Array<FileTypeGroup>, blacklist?: Array<FileTypeGroup>
	) {
		for (let fileTypeGroups of selection) {
			if (!this.check(fileTypeGroups, whitelist, blacklist)) {
				return false
			}
		}

		return true;
	}

	public checkSelection(selection: Array<string>): boolean {
		return FileTypeGroupFilter.checkSelection(selection, this.whitelist, this.blacklist);
	}

	private static filter(fileTypeGroups: string, list: Array<FileTypeGroup>): boolean {
		for (let entry of list) {
			if (entry === FileTypeGroup.ALL) {
				return true;
			}

			if (this.hasFileTypeGroup(fileTypeGroups, entry)) {
				return true;
			}
		}

		return false;
	}

	private static hasFileTypeGroup(fileTypeGroups: string, group: FileTypeGroup): boolean {
		return fileTypeGroups.indexOf(group) > -1;
	}

	get whitelist(): Array<FileTypeGroup> {
		return this._whitelist;
	}

	get blacklist(): Array<FileTypeGroup> {
		return this._blacklist;
	}
}